import type { Except } from "type-fest";
import { z } from "zod";
import type { IsoAndUnixTimestamp } from "../date-time/iso-and-unix";
import { isoAndUnixZodSchema } from "../date-time/iso-and-unix";
import type { UserId } from "../users/user-id";
import { userIdZodSchema } from "../users/user-id";
import type { WeeklySchedule } from "./weekly-schedule";
import { weeklyScheduleZodSchema } from "./weekly-schedule";
import type { WeeklyScheduleExceptionId } from "./weekly-schedule-exception-id";
import {
    weeklyScheduleExceptionIdFactory,
    weeklyScheduleExceptionIdZodSchema,
} from "./weekly-schedule-exception-id";

type WeeklyScheduleException = {
    _id: WeeklyScheduleExceptionId;
    start: IsoAndUnixTimestamp;
    end: IsoAndUnixTimestamp;
    hours: WeeklySchedule;
    _createdBy?: UserId;
};

const weeklyScheduleExceptionFactory = (
    params: Except<WeeklyScheduleException, "_id">,
): WeeklyScheduleException => ({
    _id: weeklyScheduleExceptionIdFactory(),
    ...params,
});

const weeklyScheduleExceptionZodSchema: z.ZodSchema<WeeklyScheduleException> =
    z.object({
        _id: weeklyScheduleExceptionIdZodSchema,
        _createdBy: userIdZodSchema.optional(),
        start: isoAndUnixZodSchema,
        end: isoAndUnixZodSchema,
        hours: weeklyScheduleZodSchema,
    });

export { weeklyScheduleExceptionFactory, weeklyScheduleExceptionZodSchema };
export type { WeeklyScheduleException };
